import React, { useEffect, useState } from 'react';
import { Form, Field } from 'react-final-form';
import { Row, Col, Card, CardTitle, Button } from 'reactstrap';
import { getInvoiceSummary } from '@/service/program/invoice';
import "react-datepicker/dist/react-datepicker.css";
import {format} from "date-fns";
import axios from 'axios';
import {useDispatch, flashError} from '@/shared/components/flash'
import FileldDatePicker from '@/shared/components/form/DatePickerComponent'
import {getLastMonthRange} from '@/shared/helpers'
import Error from '@/shared/components/form/FieldError'
import ViewInvoiceSummary from './ViewInvoiceSummary';

const InvoiceSummaryTab = (props) => {

    const dispatch =  useDispatch()
    const [filters, setFilters] = useState( getLastMonthRange() );
    const [loading, setLoading] = useState(false);
    const [summaryData, setSummaryData] = useState(null);

    const FilterComponent = (props) => {
        const onSubmit = async (values) => {
            values.start_date = format(new Date(values.start_date), "yyyy-MM-dd")
            values.end_date = format(new Date(values.end_date), "yyyy-MM-dd")
            setLoading(true)
            getInvoiceSummary(props.program.organization_id, props.program.id, 
                values
            )
            .then(response => {
                setSummaryData(response)
                setFilters(values)
                setLoading(false)
            })
            .catch(error => {
                flashError(dispatch, error.response.data)
                setLoading(false)
            })
        }

        const validate = values => {
            let errors = {};
            if (!values.start_date) {
                errors.start_date = 'Please select start date'
            }
            if (!values.end_date) {
                errors.end_date = 'Please select end date'
            }
            return errors
        }

        return (
            <Row>
                <Col md="12">
                    <div className="modal__title">
                        <h3 className="mb-4">Invoice Summary</h3>
                    </div>
                </Col>
                <Col sm="12">
                    <Form
                        onSubmit={onSubmit}
                        validate={validate}
                        initialValues={filters}
                    >
                        {({ handleSubmit, form, submitting, pristine, values }) => (
                        <form className="form" onSubmit={handleSubmit}>
                            <Row>
                            <Col sm="5">
                                <div className="form__form-group">
                                <span className="form__form-group-label">From</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                    <Field
                                        name="start_date"
                                        component={FileldDatePicker}
                                        validate={(value) => (value ? undefined : "This field is required")}
                                    />
                                    <Error name="start_date" />
                                    </div>
                                </div>
                                </div>
                            </Col>
                            <Col sm="5">
                                <div className="form__form-group">
                                <span className="form__form-group-label">To</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                    <Field
                                        name="end_date"
                                        component={FileldDatePicker}
                                        validate={(value) => (value ? undefined : "This field is required")}
                                    />
                                    <Error name="end_date" />
                                    </div>
                                </div>
                                </div>
                            </Col>
                            <Col sm="2" align="right">
                                <div className="form__form-group">
                                <span className="form__form-group-label d-block">&nbsp;</span>
                                <Button type="submit" disabled={submitting} className="btn btn-primary btn-sm" color="#ffffff">View</Button>
                                </div>
                            </Col>
                            </Row>
                        </form>
                        )}
                    </Form>
                </Col>
            </Row>
        )
    }

    props = { ...props, ...{ summaryData, loading } }

    const downloadSummary = () => {
        const values = filters;
        setLoading(true)
        axios.post(`/organization/${props.program.organization_id}/program/${props.program.id}/invoice-summary/download`,values,
            {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }, 
                
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Invoice-Summary.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => console.log(error));
        
        
    }
 
    return (
        <>
            <FilterComponent {...props} />
            {summaryData && <Row>
                <Col align="right">
                    <Button onClick={downloadSummary} className="btn btn-primary btn-sm" color="#ffffff">Download</Button>
                    <br/>
                </Col>
                
            </Row>}
            {summaryData && summaryData.map((invoice, index) => (
                <>
                    <ViewInvoiceSummary invoice={invoice} {...props} />
                    <br/>
                </>
            ))} 
        
        </>
    )
}

export default InvoiceSummaryTab